import { AUTOMATIC_ENROLLMENT_ALERT, MANUAL_ENROLLMENT_ALERT, NO_CRITERIA_SET_ALERT, TROUBLESHOOT_ENROLLMENT_ALERT, WILL_NOT_ENROLL_ALERT, makeEventEnrollmentFlowAlert, makeUnpredictableStaticBranchAlert } from 'automation-ui-canvas/containers/flow-views/test-flow/alerts';
import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
const useGetFlowAlerts = ({
  enrollType,
  simulatedEnrollmentResult,
  validationChecks,
  historyEvents = [],
  branchIndexOverrides,
  flow,
  shouldOverrideEventEnrollment,
  recordId,
  isEnrollmentLoading
}) => {
  let enrollmentAlert;
  const flowAlerts = [];
  const triggerType = getExistingTriggerType(flow.toHybridFlowInterface());
  if (simulatedEnrollmentResult === 'WOULD_NOT_ENROLL_NO_STARTING_LIST' && enrollType === 'DYNAMIC') {
    enrollmentAlert = NO_CRITERIA_SET_ALERT;
  } else if (enrollType === 'DYNAMIC' && flow.isEnabled) {
    enrollmentAlert = TROUBLESHOOT_ENROLLMENT_ALERT;
  } else if (triggerType === 'EVENT' && enrollType === 'DYNAMIC') {
    enrollmentAlert = {
      alert: makeEventEnrollmentFlowAlert({
        flow,
        recordId,
        context: {
          shouldOverrideEventEnrollment,
          wouldEnroll: !!shouldOverrideEventEnrollment && !(validationChecks.failed.length > 0 || simulatedEnrollmentResult === 'WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST')
        }
      }),
      shouldShowValidationChecks: !!shouldOverrideEventEnrollment
    };
  } else if (validationChecks.failed.length > 0) {
    enrollmentAlert = WILL_NOT_ENROLL_ALERT;
  } else if (enrollType === 'MANUAL' && !isEnrollmentLoading) {
    enrollmentAlert = MANUAL_ENROLLMENT_ALERT;
  } else if (!isEnrollmentLoading) {
    enrollmentAlert = AUTOMATIC_ENROLLMENT_ALERT;
  }

  /* Find unpredictable static branches: Branches that rely on field data */
  const unpredictableStaticBranchEvents = historyEvents.filter(event => {
    var _event$action;
    return ((_event$action = event.action) === null || _event$action === void 0 ? void 0 : _event$action.actionType) === 'STATIC_BRANCH' && event.executionState === 'FAIL_CONTINUE' && event.errorType === 'FIELD_DATA_MISSING';
  });
  unpredictableStaticBranchEvents.forEach(unpredictableStaticBranchEvent => {
    var _unpredictableStaticB;
    const actionId = (_unpredictableStaticB = unpredictableStaticBranchEvent.action) === null || _unpredictableStaticB === void 0 ? void 0 : _unpredictableStaticB.actionId;
    if (actionId) {
      flowAlerts.push(makeUnpredictableStaticBranchAlert({
        actionId,
        context: {
          isOverriden: branchIndexOverrides.has(actionId)
        }
      }));
    }
  });
  return {
    enrollmentAlert,
    flowAlerts
  };
};
export default useGetFlowAlerts;